export const API_URL = 'https://resumeapi.hirebeen.com';
export const CALLBACK_URL = 'https://resume.hirebeen.com';
export const GOOGLE_CLIENT_ID = "593011355655-ohrg2pet7t0tngvih4ph4dcja76i9q8d.apps.googleusercontent.com"
// export const API_URL = 'http://127.0.0.1:8000';